import dayjs from 'dayjs';

import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';

const language = document.documentElement.lang.split('-')[0].toLowerCase();

dayjs.locale(['de', 'fr', 'it'].includes(language) ? language : 'fr');
